<template>
	<main class="login-modal">
		<section class="login-hero" aria-label="Merchant portal overview">
			<div class="login-hero__content">
				<p class="login-hero__eyebrow">Merchant Portal</p>
				<h1>Manage orders with clarity.</h1>
				<p class="login-hero__copy">
					Review approvals, track customer requests, and keep store operations moving from one secure workspace.
				</p>
				<div class="login-hero__stats" aria-hidden="true">
					<div>
						<strong>Smart</strong>
						<span>Sales Tracking</span>
					</div>
					<div>
						<strong>Seamless</strong>
						<span>Business Operations</span>
					</div>
				</div>
			</div>
		</section>

		<section class="login-panel" aria-label="Merchant account login">
			<div class="login-card">
				<a class="login-back" v-on:click="backToLogin" role="button" v-if="isVerifyOTP">
					<font-awesome-icon icon="arrow-left-long"/> Back to Login
				</a>

				<div class="login-card__header">
					<img :src="logoOnlySrc" class="login-card__logo" alt="Tenny Enterprises Inc." />
					<h2>Merchant Account Login</h2>
				</div>

				<!-- <div v-if="!isVerifyOTP"> -->
				<div>
					<Alert ref="alert" class="mx-0"></Alert>
					<form class="login-form" @submit.prevent="login">
						<div class="login-field">
							<label for="account-id">Account ID</label>
							<input id="account-id" v-model="data.account_id" type="text" class="form-control" placeholder="Enter account ID" autocomplete="organization" required>
						</div>
						<div class="login-field">
							<label for="user-name">User Name</label>
							<input id="user-name" v-model="data.user_name" type="text" class="form-control" placeholder="Enter user name" autocomplete="username" required>
						</div>
						<div class="login-field">
							<label for="password">Password</label>
							<div class="login-password">
								<input id="password" v-model="data.password" :type="passwordFieldType" class="form-control" placeholder="Enter password" autocomplete="current-password" required>
								<button type="button" class="login-password__toggle" @click="togglePasswordVisibility" :aria-label="showPassword ? 'Hide password' : 'Show password'">
									<i :class="eyeIcon"></i>
								</button>
							</div>
						</div>
						<div class="login-actions">
							<router-link to="/forgot-password">Forgot Password?</router-link>
						</div>
						<button type="submit" class="btn login-submit">Login</button>
					</form>
				</div>
				<!-- <div class="container pt-3" v-else>
					<Alert ref="alert" class="mx-0"></Alert>
					<p> OTP has been sent in your registered number.</p>
					<div class="form-group pb-5">
						<input type="text" v-model="data.otp_code" class="form-control mt-4" placeholder="OTP" @input="integersOnly" required>
						<div class="text-end pt-2">
							<a class="text-primary" role="button" @click="resendOTP">
								Request New OTP
							</a>
						</div>
					</div>
					<div>
						<button class="btn btn-primary w-100" @click="verifyOTP">Verify</button>
					</div>
				</div> -->
				<div class="login-card__footer">
					<i class="fa-regular fa-copyright"></i>
					2024 Tenny Enterprises Inc. All rights reserved.
				</div>
			</div>
		</section>
	</main>
</template>

<script src="./LoginScript.vue"/>
